import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';

import { AudienceMessageForm } from './audience-message-form';

interface OpeningCardProps {
  openingId: string;
}

export function OpeningCard({ openingId }: OpeningCardProps) {
  const { hookForm } = useJobPostingContext();
  const { getValues } = hookForm;

  const openingTitle = getValues(`jobDetails.${openingId}.title`);

  return (
    <div className="border-fx-neutral-200 mb-3 w-[640px] rounded-lg border bg-white py-6 px-12 shadow-sm">
      <div className="flex flex-1 flex-col gap-6 ">
        {/* Opening title */}
        <div className="flex flex-col gap-1">
          <Typography variant="caption" className="!text-fx-neutral-500">
            <FormattedMessage
              defaultMessage="Opening"
              description="Opening section title"
            />
          </Typography>
          <Typography variant="body2">{openingTitle}</Typography>
        </div>

        <AudienceMessageForm openingId={openingId} />
      </div>
    </div>
  );
}
